import { useStaticQuery, graphql } from 'gatsby';
import type { AllFontsQuery } from '../gql/api-ssr';
import useConfig from './useConfig';
import isWhitelisted from '../utils/isWhitelisted';
import useIsUserTestingSite from './useIsUserTestingSite';

export type FontFamilyGroup = AllFontsQuery['ssr']['fontFamilyGroups'][number];
export type FontFamily = FontFamilyGroup['fontFamilies'][number];

export default function useFontFamilyGroupStubs(): FontFamilyGroup[] {
    const config = useConfig();
    const isUserTestingSite = useIsUserTestingSite();
    const query = useStaticQuery<AllFontsQuery>(graphql`
        query AllFontsQuery {
            ssr {
                fontFamilyGroups {
                    __typename
                    id
                    name
                    slug
                    isCollection
                    svgNavigation
                    typographicRanking
                    colorSchemes {
                        backgroundColor: colorBackground
                        foregroundColor: colorForeground
                        highlightColor: colorHighlight
                        backgroundColorAlt: colorBackgroundAlt
                        foregroundColorAlt: colorForegroundAlt
                        highlightColorAlt: colorHighlightAlt
                    }
                    fontFamilies {
                        id
                        name
                        slug
                        isPreRelease
                        fontStyleCount
                        typographicRanking
                        mainFontStyle {
                            id
                            productName
                        }
                        cssRenderInfo {
                            fontFamilyName
                            isItalic
                            variableAxisValues {
                                tag
                                value
                            }
                            woff2Path
                            fontWeight
                        }
                        renderFontMetrics {
                            unitsPerEmHead
                            capHeightCalc
                            ascentCalc
                            ascentHhea
                            descentCalc
                            descentHhea
                            lineGapHhea
                        }
                    }
                }
            }
        }
    `);

    return (
        query.ssr.fontFamilyGroups.filter((fontFamilyGroup) => {
            if (!isUserTestingSite) {
                return true;
            }
            return isWhitelisted(
                config.userTestingFontFamilyGroupWhitelist,
                fontFamilyGroup.id,
            );
        }) || []
    );
}
